module.exports = __webpack_public_path__ + "static/media/cf_eats_logo.6ceaa3ac.png";